import { JsonObject } from 'json2typescript';
import GoodsOption from './GoodsOption';

@JsonObject('GoodsOptionType')
export default class GoodsOptionType {
  constructor() {
    this.goodsOptionTypeId = 0;
    this.goodsOptionTypeTitle = '';
    this.goodsOptions = new Array<GoodsOption>();

    this.value = 0;
    this.validateMessage = '';
  }

  public goodsOptionTypeId: number;

  public goodsOptionTypeTitle: string;

  public goodsOptions: Array<GoodsOption>;

  /** 編集用 */
  public value: number;

  public get innerValue(): string {
    return `${this.value}`;
  }

  public set innerValue(v: string) {
    this.value = Number(v);
  }

  public get text(): string {
    if (this.value < 1) {
      return '';
    }
    const selectedOption = this.goodsOptions.find((v) => v.goodsOptionId === this.value);
    if (selectedOption === undefined) {
      return '';
    }
    return selectedOption.optionTitle;
  }

  public validateMessage: string;
}
